import {action, observer, observable, React, useLocalStore, useEffect} from '@api'
import {MouseButtons} from '@constants'
import {useVipLocalStore, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'

import * as css from './SidebarSplitter.css'

class MyStore extends VipLocalStore {
  @observable isResizing = false
  @observable startX = 0
  @observable initialWidth: number
  @observable startSidebarWidth: number
  constructor(stores: StoresInstance) {
    super(stores)
    this.initialWidth = this.sidebar.width
  }

  private _onMouseMove = (e: MouseEvent) => {
    const {isResizing, startX, sidebar, initialWidth} = this
    if (isResizing) {
      if (e.buttons != MouseButtons.Left) {
        this.isResizing = false
      }
      else {
        const deltaX = e.screenX - startX
        //console.log(`_onMouseMove`, deltaX, e)
        sidebar.width = initialWidth + deltaX
      }
    }
  }

  private _onMouseUp = (e: MouseEvent) => {
    console.log(`_onMouseUp`, e)
    this.isResizing = false
  }

  registerEffects = () => {
    const {_onMouseMove, _onMouseUp} = this
    window.addEventListener('mousemove', _onMouseMove)
    window.addEventListener('mouseup', _onMouseUp)

    return () => {
      window.removeEventListener('mousemove', _onMouseMove)
      window.removeEventListener('mouseup', _onMouseUp)
    }
  }

  get sidebar() {
    return this.stores.sidebar.left
  }
  @action onMouseDown = (e: React.MouseEvent) => {
    console.log(`onMouseDown`, e)
    if (e.buttons == MouseButtons.Left) {
      this.isResizing = true
      this.startX = e.pageX
      this.startSidebarWidth = this.sidebar.width
    }
  }

  @action onDoubleClick = (e: React.MouseEvent) => {
    console.log(`onDoubleClick`, e)
    const {sidebar, initialWidth} = this
    sidebar.width = initialWidth
  }
}
export const SidebarSplitter = observer(({align}: { align: 'left' | 'right' }) => {
  const { registerEffects, onMouseDown, onDoubleClick} = useVipLocalStore((ws) => new MyStore(ws))

  useEffect(() => registerEffects(), [])

  return <div className={css.root} onMouseDown={onMouseDown} onDoubleClick={onDoubleClick}>
  </div>
})



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/SidebarSplitter.tsx